import _ from 'lodash';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Language, Model as SettingsModel } from '@api/models/settings';
import * as actions from './actions';

type Settings = Omit<SettingsModel, '_id'> & {
  lang: Language;
};

const initialState: Settings = {
  lang: 'he',
  texts: {},
};

export const settings = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<actions.Init>) => {
      state.texts = action.payload.texts;
    },
  },
});

export const { init } = settings.actions;
export default settings.reducer;
